import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=570b51f7&scoped=true&"
import script from "./RadioButton.vue?vue&type=script&lang=js&"
export * from "./RadioButton.vue?vue&type=script&lang=js&"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=570b51f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b51f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570b51f7')) {
      api.createRecord('570b51f7', component.options)
    } else {
      api.reload('570b51f7', component.options)
    }
    module.hot.accept("./RadioButton.vue?vue&type=template&id=570b51f7&scoped=true&", function () {
      api.rerender('570b51f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Input/RadioButton.vue"
export default component.exports